import { useDispatch, useSelector } from 'react-redux';
import { closeSession, selectSession } from '@client';
import { useClerkClientAuth } from '@client/hooks/useClerkClientAuth';
import { posthogReset } from '@shared/posthog';

export const useClientSignOut = () => {
  const dispatch = useDispatch();
  const { clerkSignOut } = useClerkClientAuth();

  return () => {
    dispatch(closeSession());
    posthogReset();
    clerkSignOut({ redirectUrl: '/' });
  };
};

const removeTableFilters = (): void => {
  localStorage.removeItem('clientsSearchText');

  const prefixes = ['columnVisibility:', 'sorting:'];

  Object.keys(localStorage)
    .filter(key => prefixes.some(prefix => key.startsWith(prefix)))
    .forEach(key => localStorage.removeItem(key));
};

export const useSignOut = () => {
  const dispatch = useDispatch();
  const session = useSelector(selectSession);
  const { clerkSignOut, clerkEmail } = useClerkClientAuth();
  const email = clerkEmail || session.advisor?.advisorEmail;

  return () => {
    removeTableFilters();
    dispatch(closeSession());
    posthogReset();
    clerkSignOut({ redirectUrl: `/?email=${encodeURIComponent(email ?? '')}` });
  };
};
